export function initDetector(callback: (level: number) => void) {
    const detector = document.createElement('div');
    detector.id = 'detector';

    document.body.appendChild(detector);

    let oldW = -1;

    function detect() {
        let w = detector.clientWidth;
        if (w != oldW) {
            oldW = w;
            callback(w);
        }
    }

    window.addEventListener('resize', detect);

    detect();
}

